// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { staticListHeaderStyles } from "@insite/content-library/Widgets/StaticList/StaticListHeader";
import { css } from "styled-components";

staticListHeaderStyles.infoGridItem = {
    width: [12, 7, 6, 7, 8],
    css: css`
        flex-direction: column;
    `,
};

staticListHeaderStyles.saveListGridItem = {
    width: [12, 2, 3, 2, 2],
    css: css`
        justify-content: flex-end;
    `,
};

staticListHeaderStyles.addListToCartGridItem = {
    width: [12, 3, 3, 3, 2],
};

staticListHeaderStyles.saveListButton = {
    variant: "secondary",
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        width: 100%;
    `,
};

staticListHeaderStyles.addListToCartButton = {
    css: css`
        width: 100%;
    `,
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    },
};

staticListHeaderStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    `,
};
